import { Select, Tooltip } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RegionOption } from '../../../types/phlebotomist-dashboard';

interface IRegionMultiSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  regions: RegionOption[];
  loading?: boolean;
  placeholder?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

export const RegionMultiSelect: FC<IRegionMultiSelectProps> = ({
  value,
  onChange,
  regions,
  loading = false,
  placeholder,
  disabled = false,
  disabledTooltip,
}) => {
  const { t } = useTranslation('dashboard.PhlebotomistDashboard');

  const options = useMemo(() => {
    return regions.map((region) => ({
      value: region.id,
      label: region.name,
    }));
  }, [regions]);

  const handleChange = (selectedValues: string[]) => {
    onChange(selectedValues);
  };

  const select = (
    <Select
      mode="multiple"
      value={value}
      onChange={handleChange}
      options={options}
      loading={loading}
      style={{ width: '100%', minWidth: 0 }}
      placeholder={placeholder || t('filters.allRegions', 'All Regions')}
      allowClear
      maxTagCount="responsive"
      disabled={disabled}
    />
  );

  // Wrap in tooltip when disabled
  if (disabled && disabledTooltip) {
    return <Tooltip title={disabledTooltip}>{select}</Tooltip>;
  }

  return select;
};

export default RegionMultiSelect;
